/**
 * Tailwind class strings for order list / drawer actions.
 * Strong disabled affordance: lower opacity + muted surface so disabled ≠ enabled.
 */
export const orderDrawerPrimaryButtonClass =
  "px-3 py-2 rounded-lg text-sm font-medium bg-[#FD7657] text-white transition-colors hover:bg-[#e56a4a] disabled:opacity-[0.38] disabled:saturate-50 disabled:cursor-not-allowed disabled:hover:bg-[#FD7657]";

export const orderDrawerSecondaryButtonClass =
  "px-3 py-2 rounded-lg text-sm font-medium border border-[#d1d5db] text-[#374151] bg-white transition-colors hover:bg-[#f9fafb] disabled:opacity-[0.5] disabled:bg-[#f3f4f6] disabled:text-gray-400 disabled:border-[#e5e7eb] disabled:cursor-not-allowed disabled:hover:bg-[#f3f4f6]";

export const orderDrawerCompactSecondaryButtonClass =
  "inline-flex items-center justify-center h-8 px-2 rounded-md text-[12px] font-medium border border-[#d1d5db] text-[#374151] bg-white whitespace-nowrap shrink-0 transition-colors hover:bg-[#f9fafb] disabled:opacity-[0.5] disabled:bg-[#f3f4f6] disabled:text-gray-400 disabled:border-[#e5e7eb] disabled:cursor-not-allowed disabled:hover:bg-[#f3f4f6]";

/**
 * Table ⋮ menu rows (Details / Print / Edit / Pay).
 * Use arbitrary opacity — tailwind.config.js replaces default opacity scale (no opacity-50, etc.).
 */
export const orderTableMenuItemClass =
  "w-full text-left px-3 py-2 text-sm text-gray-800 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:bg-[#eceef1] disabled:text-gray-400 disabled:hover:bg-[#eceef1] disabled:opacity-[0.72] disabled:grayscale";

/** Recent orders flow: light coral ghost buttons (Update tip / Capture) */
export const orderGhostCoralButtonClass =
  "bg-[#FD76571A] text-[#FD7657] px-3 py-2 rounded-md text-xs font-medium transition-colors hover:bg-[#FD765730] disabled:opacity-[0.45] disabled:saturate-50 disabled:grayscale-[0.2] disabled:cursor-not-allowed disabled:hover:bg-[#FD76571A]";

export const orderGhostCoralButtonWideClass =
  "bg-[#FD76571A] text-[#FD7657] px-4 py-2 rounded-md text-xs font-medium transition-colors hover:bg-[#FD765730] disabled:opacity-[0.45] disabled:saturate-50 disabled:grayscale-[0.2] disabled:cursor-not-allowed disabled:hover:bg-[#FD76571A]";
